import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

//form
import Login from './login';
import Utama from './utama';
// import ProtectedRoute from "./ProtectedRoute";

// const url_aplikasi = "http://localhost/gkr_api";
// const url_file = "http://localhost/gkr_file";
// const basename = "";

// const url_aplikasi = "https://dev-resto.keisharesto.com/gkr_api";
// const url_file = "https://dev-resto.keisharesto.com/gkr_file";
// const basename = "";

const url_aplikasi = "https://keisharesto.com/gkr_api";
const url_file = "https://keisharesto.com/gkr_file";
const basename = "";

function App() {
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route
          path="/login"
          element={
            <Login
              aplikasi={url_aplikasi}
              file={url_file}
            />
          }
        />
        <Route
          path="*"
          element={
            <Utama
              aplikasi={url_aplikasi}
              file={url_file}
            />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;